module.exports = __webpack_public_path__ + "img/logo.aa5d5069.png";